var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c(
        "el-form",
        {
          ref: "contForm",
          staticClass: "cont-form",
          attrs: { size: "small", model: _vm.contractInfo }
        },
        [
          _c(
            "div",
            { staticClass: "f-top" },
            [
              _c("el-form-item", [_c("h4", [_c("i"), _vm._v("模板名称")])]),
              _c(
                "el-form-item",
                {
                  staticClass: "s-er",
                  attrs: { prop: "tplName", rules: _vm.myRules.tplName }
                },
                [
                  _c(
                    "el-row",
                    { staticStyle: { width: "550px" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入模板名称",
                          readonly: _vm.isPreview()
                        },
                        on: { blur: _vm.validContractName },
                        model: {
                          value: _vm.contractInfo.tplName,
                          callback: function($$v) {
                            _vm.$set(_vm.contractInfo, "tplName", $$v)
                          },
                          expression: "contractInfo.tplName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "f-top" },
            [
              _c("el-form-item", [_c("h4", [_c("i"), _vm._v("模板文件")])]),
              _c("el-form-item", [
                _c("div", { staticClass: "input-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "input-box" },
                    [
                      !_vm.contractFile.fileName
                        ? [
                            _c("span", { staticClass: "el-icon-plus" }),
                            _c("br"),
                            _c("p", [_vm._v("上传docx/doc/pdf格式文件")])
                          ]
                        : [
                            _c("div", { staticClass: "f-box" }, [
                              _c("div", { staticClass: "bx" }, [
                                _vm.fileSuffix(_vm.contractFile.fileName) ===
                                "pdf"
                                  ? _c("img", {
                                      attrs: {
                                        src: "/images/advancedVersion/pdf.png"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.fileSuffix(_vm.contractFile.fileName) ===
                                  "doc" ||
                                _vm.fileSuffix(_vm.contractFile.fileName) ===
                                  "docx"
                                  ? _c("img", {
                                      attrs: {
                                        src: "/images/advancedVersion/word.png"
                                      }
                                    })
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "msk",
                                    style: {
                                      display: _vm.isPreview() ? "none" : ""
                                    }
                                  },
                                  [
                                    _c("a", { on: { click: _vm.reUpload } }, [
                                      _vm._v("重新上传")
                                    ])
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                { attrs: { title: _vm.contractFile.fileName } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.contractFile.fileName) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ],
                      _c("input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isPreview(),
                            expression: "!isPreview()"
                          }
                        ],
                        ref: "contractFileInput",
                        attrs: { type: "file" },
                        on: { change: _vm.contractFileUpload }
                      })
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "fj-wrap" },
                    [
                      !_vm.isPreview()
                        ? [
                            _c("span", { staticClass: "fj-box" }, [
                              _c("span", {
                                staticClass: "icon-fj",
                                staticStyle: { "vertical-align": "text-bottom" }
                              }),
                              _vm._v(
                                "添加附属材料（" +
                                  _vm._s(_vm.enclosureFiles.length) +
                                  "/3)\n                "
                              ),
                              _c("input", {
                                ref: "attatchFileInput",
                                attrs: { type: "file" },
                                on: { change: _vm.handleAttatchFileUpload }
                              })
                            ]),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  placement: "bottom-start"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  支持任意格式文件；"
                                    ),
                                    _c("br"),
                                    _vm._v("最多可添加3个附件，每个最大30M；"),
                                    _c("br"),
                                    _vm._v(
                                      "为固定附属材料，模板使用人可添加，不可删除"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "仅供参与方查阅，不用于签署\n                "
                                    )
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    "font-size": "16px",
                                    "margin-left": "10px",
                                    color: "#a1a1a1",
                                    cursor: "pointer",
                                    "margin-right": "50px"
                                  }
                                })
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm.enclosureFiles && _vm.enclosureFiles.length
                        ? [
                            _vm._l(_vm.enclosureFiles, function(item, index) {
                              return [
                                _c("span", { key: index, staticClass: "fj" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(_vm._s(item.fileName))
                                  ]),
                                  _c("span", {
                                    staticClass: "el-icon-error",
                                    on: {
                                      click: function($event) {
                                        return _vm.delAttatch(item, index)
                                      }
                                    }
                                  })
                                ])
                              ]
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "text-center" },
            [
              _c(
                "el-button",
                {
                  staticClass: "abtn",
                  attrs: { type: "danger" },
                  on: { click: _vm.nextStep }
                },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "com-myDialog",
          attrs: {
            title: "提示",
            visible: _vm.tipsDialogVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.tipsDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "con" }, [
            _c("p", { staticStyle: { "margin-top": "40px" } }, [
              _c("span", { staticClass: "el-icon-warning" }),
              _vm._v("当前内容还未保存，确认退出编辑？\n      ")
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      ;(_vm.tipsDialogVisible = false), (_vm.sureEdit = false)
                    }
                  }
                },
                [_vm._v("继续填写")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmEdit } },
                [_vm._v("仍然退出")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d4d818e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d4d818e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/advancedVersion/APICust/addTp.vue
// module id = 79qT
// module chunks = 163